module.exports = Function.call.bind(Object.prototype.hasOwnProperty);



// WEBPACK FOOTER //
// /codebuild/output/src2416834937/src/pobble-app/client/~/@fortawesome/react-fontawesome/~/prop-types/lib/has.js